import dayjs from "dayjs";
import { useIntl } from "react-intl";

import { travellerTitleMessages } from "@/features/travellers/utils/travellerTitles";
import type { FindUserTravelersTravelers } from "@/types/codegen";

const TravellerInfoRow = ({
  label,
  value,
}: {
  label: string;
  value?: string;
}) => (
  <div className="flex justify-between">
    <span className="text-sm font-normal text-text-tertiary">{label}</span>
    <span className="text-sm font-medium text-text-primary">
      {value ?? "-"}
    </span>
  </div>
);

type Props = {
  traveller: FindUserTravelersTravelers;
};

export const TravellerDetailsCard = ({ traveller }: Props) => {
  const intl = useIntl();

  return (
    <div className="section-card">
      <div className="mb-4 text-lg font-medium text-text-primary">
        {traveller.firstName} {traveller.lastName}
      </div>
      <div className="space-y-3">
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Name",
            description: "Label for the traveller's first name field",
          })}
          value={traveller.firstName}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Surname",
            description: "Label for the traveller's last name / surname field",
          })}
          value={traveller.lastName}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Date of Birth",
            description: "Label for the traveller's date of birth field",
          })}
          value={intl.formatDate(traveller.birthDate, {
            dateStyle: "short",
          })}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Title",
            description: "Label for the traveller's title field",
          })}
          value={intl.formatMessage(travellerTitleMessages[traveller.title])}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Nationality",
            description: "Label for the traveller's nationality field",
          })}
          value={traveller.passportNationality}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Email",
            description: "Label for the traveller's email address field",
          })}
          value={traveller.emailAddress}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Passport ID",
            description: "Label for the passport number field",
          })}
          value={traveller.passportNumber}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Passport Issue Date",
            description: "Label for the passport issue date field",
          })}
          value={intl.formatDate(
            dayjs(traveller.passportIssuingDate).toDate(),
            {
              dateStyle: "short",
            },
          )}
        />
        <TravellerInfoRow
          label={intl.formatMessage({
            defaultMessage: "Passport Expiry Date",
            description: "Label for the passport expiry date field",
          })}
          value={intl.formatDate(dayjs(traveller.passportExpiryDate).toDate(), {
            dateStyle: "short",
          })}
        />
      </div>
    </div>
  );
};
